import {Gear} from './gear.model';

/**
 * Extension from the Gear class
 */
export class PelagicGear extends Gear {
    
    totalNumLinesRods!: number;

    numHooksPerLineRod!: number;

    NT_RCA!: boolean;

  static transformAnonymous(anon: any): PelagicGear {
        let pel = new PelagicGear();
        pel.gearID = anon.gearID;
        pel.fishingEventID = anon.fishingEventID;
        pel.identifier = anon.identifier;
        pel.type = anon.type;
        pel.gearSubtype = anon.gearSubtype;
        pel.totalNumLinesRods = anon.totalNumLinesRods;
        pel.numHooksPerLineRod = anon.numHooksPerLineRod;
        pel.NT_RCA = anon.NT_RCA ? anon.NT_RCA : false;
        pel.fishery = 'Groundfish';
        return pel;
    }


    constructor() {
        super();
        this.type = "Pelagic";
    }

    isEqual(cmp: PelagicGear) {
        return this.identifier == cmp.identifier && 
        this.totalNumLinesRods == cmp.totalNumLinesRods &&
        this.numHooksPerLineRod == cmp.numHooksPerLineRod &&
        this.NT_RCA == cmp.NT_RCA &&
        this.gearSubtype.id == cmp.gearSubtype.id &&
        this.gearSubtype.lookupType == cmp.gearSubtype.lookupType;
    }

    toString() {
        if (this.identifier == '')
            return '';
      return this.identifier + " -- " + this.gearSubtype.name + " -- " + (this.NT_RCA ? "RCA" : "Non-RCA")  + " -- " + this.totalNumLinesRods + " rods -- " + this.numHooksPerLineRod + " Hooks/Rod";
    }
}
